/* Native disclosure controls remain usable without JavaScript. */
(() => {
  const closeMenus = (except) => document.querySelectorAll('.wb-nav-item[open]').forEach(menu => { if (menu !== except) menu.open = false; });
  document.addEventListener('toggle', event => {
    if (event.target.matches('.wb-nav-item') && event.target.open) closeMenus(event.target);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement?.closest('.wb-nav-item[open], .wb-mobile-menu[open]');
    if (active) { active.open = false; active.querySelector('summary')?.focus(); }
    else closeMenus();
  });
  document.addEventListener('click', event => { if (!event.target.closest('.wb-header')) closeMenus(); });
})();
